import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as sodium from 'libsodium-wrappers';
import { windowRef } from '../../MockWindow';
import { ExtensionMessageTarget, Origin, Serializer } from '../..';
import { openCryptobox } from '../../utils/crypto';
import { getSenderId } from '../../utils/get-sender-id';
import { MessageBasedClient } from './MessageBasedClient';
/**
 * @internalapi
 *
 *
 */

export var PostMessageClient = /*#__PURE__*/function (_MessageBasedClient) {
  _inherits(PostMessageClient, _MessageBasedClient);

  var _super = _createSuper(PostMessageClient);

  function PostMessageClient() {
    var _this;

    _classCallCheck(this, PostMessageClient);

    _this = _super.apply(this, arguments);
    _this.activeListeners = new Map();
    return _this;
  }

  _createClass(PostMessageClient, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.subscribeToMessages().catch(console.error);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "listenForEncryptedMessage",
    value: function listenForEncryptedMessage(senderPublicKey, messageCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var callbackFunction;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.activeListeners.has(senderPublicKey)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                callbackFunction = function callbackFunction(message, context) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var decryptedMessage;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return this.decryptMessage(senderPublicKey, message.encryptedPayload);

                          case 3:
                            decryptedMessage = _context2.sent;
                            // console.log('calculated sender ID', await getSenderId(senderPublicKey))
                            // TODO: Add check for correct decryption key / sender ID
                            messageCallback(decryptedMessage, context);
                            _context2.next = 9;
                            break;

                          case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2["catch"](0);

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this, [[0, 7]]);
                  }));
                };

                this.activeListeners.set(senderPublicKey, callbackFunction);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message, peer) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var payload, targetId, msg;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.encryptMessage(peer.publicKey, message);

              case 2:
                payload = _context4.sent;
                targetId = (_a = peer) === null || _a === void 0 ? void 0 : _a.extensionId; // if no targetId, we remove peer

                msg = {
                  target: ExtensionMessageTarget.EXTENSION,
                  encryptedPayload: payload,
                  targetId: targetId
                }; // eslint-disable-next-line @typescript-eslint/no-explicit-any

                windowRef.postMessage(msg, windowRef.location.origin);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "listenForChannelOpening",
    value: function listenForChannelOpening(messageCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;

        var fn;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fn = function fn(event) {
                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                    var _a, _b, data, payload, pairingResponse;

                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            data = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.message;
                            _context5.t0 = data && data.target === ExtensionMessageTarget.PAGE;

                            if (!_context5.t0) {
                              _context5.next = 6;
                              break;
                            }

                            _context5.next = 5;
                            return this.isChannelOpenMessage(data);

                          case 5:
                            _context5.t0 = _context5.sent;

                          case 6:
                            if (!_context5.t0) {
                              _context5.next = 29;
                              break;
                            }

                            payload = Buffer.from(data.payload, 'hex');

                            if (!(payload.length >= sodium.crypto_secretbox_NONCEBYTES + sodium.crypto_secretbox_MACBYTES)) {
                              _context5.next = 29;
                              break;
                            }

                            _context5.prev = 9;
                            _context5.t1 = JSON;
                            _context5.next = 13;
                            return openCryptobox(payload, this.keyPair.publicKey, this.keyPair.privateKey);

                          case 13:
                            _context5.t2 = _context5.sent;
                            pairingResponse = _context5.t1.parse.call(_context5.t1, _context5.t2);
                            _context5.t3 = messageCallback;
                            _context5.t4 = Object;
                            _context5.t5 = Object.assign({}, pairingResponse);
                            _context5.next = 20;
                            return getSenderId(pairingResponse.publicKey);

                          case 20:
                            _context5.t6 = _context5.sent;
                            _context5.t7 = (_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.sender.id;
                            _context5.t8 = {
                              senderId: _context5.t6,
                              extensionId: _context5.t7
                            };
                            _context5.t9 = _context5.t4.assign.call(_context5.t4, _context5.t5, _context5.t8);
                            (0, _context5.t3)(_context5.t9);
                            _context5.next = 29;
                            break;

                          case 27:
                            _context5.prev = 27;
                            _context5.t10 = _context5["catch"](9);

                          case 29:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, this, [[9, 27]]);
                  }));
                };

                windowRef.addEventListener('message', fn);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }, {
    key: "sendPairingRequest",
    value: function sendPairingRequest(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var message;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.t0 = ExtensionMessageTarget.EXTENSION;
                _context7.t1 = new Serializer();
                _context7.next = 4;
                return this.getPairingRequestInfo();

              case 4:
                _context7.t2 = _context7.sent;
                _context7.next = 7;
                return _context7.t1.serialize.call(_context7.t1, _context7.t2);

              case 7:
                _context7.t3 = _context7.sent;
                _context7.t4 = id;
                message = {
                  target: _context7.t0,
                  payload: _context7.t3,
                  targetId: _context7.t4
                };
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                windowRef.postMessage(message, windowRef.location.origin);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "isChannelOpenMessage",
    value: function isChannelOpenMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", typeof message === 'object' && message.hasOwnProperty('payload'));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }, {
    key: "subscribeToMessages",
    value: function subscribeToMessages() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                windowRef.addEventListener('message', function (message) {
                  if (typeof message === 'object' && message) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var data = message.data;

                    if (data.message && data.message.target === ExtensionMessageTarget.PAGE) {
                      _this4.activeListeners.forEach(function (listener) {
                        listener(data.message, {
                          origin: Origin.EXTENSION,
                          id: data.sender.id || ''
                        });
                      });
                    }
                  }
                });

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    }
  }]);

  return PostMessageClient;
}(MessageBasedClient);